<script lang="ts" setup>
import type { ProductData } from '~/types/products'

const props = defineProps<{
  productData: ProductData
  tagsData?: any
}>()

const benefits = computed(() => props.productData.attributes.benefits)
const descriptionHtml = computed(() => props.productData.attributes.descriptionHtml)
const recommendedFor = computed(() => props.productData.attributes.recommendedFor)
</script>

<template>
  <div>
    <TaxonomyCarousel v-if="tagsData.length" class="mb-4" :tags-data="tagsData" />

    <HtmlArea v-if="descriptionHtml" :plain-html="descriptionHtml" />
    <Notification v-else status="info">
      Нет описания.
    </Notification>

    <template v-if="benefits">
      <h4 class="mt-10">
        Чем полезен
      </h4>

      <pre class="pre-wrap">{{ benefits }}</pre>
    </template>

    <template v-if="recommendedFor">
      <h4 class="mt-10">
        Кому рекомендуется
      </h4>

      <pre class="pre-wrap">{{ recommendedFor }}</pre>
    </template>
  </div>
</template>
